import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';
import { size as _size, isEqual as _isEqual } from 'lodash';
import Konva from 'konva';
import { Stage, Layer, Rect, Text, Circle, Line, Image, Label, Tag, Group } from 'react-konva';

import { SquaredButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection';
import Spinner from '../builder/Spinner';
import Tooltip from '../builder/Tooltip.js';

const Legend = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const items = props.items;

	return (
		<div class="game_legend gui_main_text_color_on_bg">
			{items.map((item, i) => {
				const item_found = (item.found != undefined && item.found) ? item.found : false;
				const item_name = (item.name != undefined && item.name != "") ? item.name : i18n("Area") + "_" + i;

				return(
					<span key={i} class={((item_found) ? 'selected ____original_color_item' : '')}>{item_name}</span>
				)
			})}
		</div>
	)
}

class SearchCanvas extends Component {
	constructor(props, context) {
		super(props, context);

		let a = [];
		if (props.areas != undefined) {
			for (var i in props.areas) {
				a.push({...props.areas[i]});
			}
		}

		this.state = {
			areas:a,
			attempts_array:[],
			full_loaded:false,
			hover_area:false,
			image:(props.image != undefined) ? props.image : false,
			image_search:{},
		};

		this.ok_color = props.color_ok; // green
		this.ok_color_hover = '155, 195, 140'; // light green
		this.creating_color = props.color_ko; // red
		this.ko_color = props.color_ko; // red

		this.intersection_threshold = 25; // number of segments to divide evaluating line to check for intersections
		this.is_zooming = false;
		this.is_dragging = false;
		this.tap_pos = {
			x:0,
			y:0,
		};

		this.is_builder = (props.is_builder != undefined) ? props.is_builder : false;

		this.size = 600;
		this.new_polygon = {};

		this.lastDist = 0;

		this.success_sound = props.sound_fx.success;
		this.error_sound = props.sound_fx.error;

		this.in_widget = ($('html').hasClass('in_iframe')) ? true : false;

		if(props.stageInstance != undefined) props.stageInstance(this);

		this.default_cache_props = { pixelRatio:2, imageSmoothingEnabled:true, offset:5, drawBorder:false };
	}

	/*START SOUNDS*/
	errorPlay() {
		this.error_sound.play();
	}

	successPlay() {
		this.success_sound.play();
	}
	/*END SOUNDS*/

	componentWillReceiveProps(props) {
		if(!_isEqual(props.areas,this.state.areas) || props.image != this.props.image) {
			if(props.image != this.props.image) {
				this.state.image = props.image!= undefined ? props.image : false;
				this.gameInit();
			}
			if(!_isEqual(props.areas,this.props.areas)) {
				this.state.areas = props.areas;
			}
		}

		if(props.to_reset != this.props.to_reset) {
			this.resetGame();
		}
	}

	resetGame() {
		this.state.full_loaded = false;
		this.state.attempts_array = [];
		this.state.areas.map((area, i) => {
			if(area.found != undefined){
				delete this.state.areas[i].found;
			}
		});

		this.setState({...this.state});
		this.gameInit();
	}

	componentDidMount() {
		const t = setTimeout(() => {
			this.gameInit();
		}, ((!this.is_builder) ? 4500 : 100));

		window.onresize = () => { this.gameInit(true); }
		//this.initDrawMethods();
	}

	initDrawMethods() {
		var isPaint = false;
		var lastLine;

		this.refs.stage.on('mousedown touchstart', (e) => {
			isPaint = true;
			var pos = this.refs.stage.getPointerPosition();
			lastLine = new Konva.Line({
				stroke:'#df4b26',
				strokeWidth:40,
				hitStrokeWidth:60,
				lineCap:'round',
				lineJoin:'round',
				globalCompositeOperation:'source-over',
				points:[pos.x, pos.y],
			});

			this.refs.layer.add(lastLine);
		});

		this.refs.stage.on('mouseup touchend', () => {
			isPaint = false;

			lastLine.on('click tap', () => {
			});
		});

		// and core function - drawing
		this.refs.stage.on('mousemove touchmove', () => {
			if(!isPaint) return;

			const pos = this.refs['stage'].getPointerPosition();
			var newPoints = lastLine.points().concat([pos.x, pos.y]);
			lastLine.points(newPoints);
			this.refs.layer.batchDraw();
		});
	}

	gameInit(from_resize) {
		if(from_resize == undefined) from_resize = false;

		if(this.props.adaptToContainer != undefined) this.props.adaptToContainer((size) => {
			this.size = size;
			this.loadImages();
		});
	}

	loadImages() {
		var image_search = new window.Image();
		image_search.crossOrigin = 'Anonymous';
		image_search.src = this.state.image;

		if(this.refs.bg_image != undefined) this.refs.bg_image.clearCache();

		image_search.onload = () => {
			this.setState({image_search:{
				_src:image_search,
				_w:image_search.width,
				_h:image_search.height,
				_scalex:this.size / image_search.width,
				_scaley:this.size / image_search.height,
			}, full_loaded:true});

			setTimeout(() => {
				this.refs.bg_image.cache(this.default_cache_props).draw();
			}, 100);
		}
	}

	clickImage(e) {
		const pos = this.refs['stage'].getPointerPosition();

		if(!this.is_builder) {
			this.clickImageTapEmulated(pos);
		} else {
			this.checkPosition(pos);
		}
	}

	clickImageTapEmulated(pos) {
		this.is_zooming = false;
		this.is_dragging = false;

		const has_found = this.refs.layer.getIntersection({ x:pos.x, y:pos.y }, 'Line');

		if(!has_found) {
			this.state.attempts_array.push({
				x:(pos.x - this.refs['stage'].x()) / this.refs['stage'].scaleX(),
				y:(pos.y - this.refs['stage'].y()) / this.refs['stage'].scaleY(),
				error:true,
			});

			if(this.props.onFireAttempt != undefined) this.props.onFireAttempt({
				error:true,
			});

			this.errorPlay();

			this.setState({...this.state});
			this.isSolved();
		}
	}

	removeLast() {
		const num_points = _size(this.new_polygon.points);
		if(num_points > 2) {
			this.new_polygon.points.splice(num_points - 2, 2);

			this.redrawLayer();
			this.setState({...this.state});
		}
	}

	redrawLayer() {
		this.refs.layer.draw();
	}

	removePoint() {
		this.new_polygon = {};
		this.redrawLayer();
		this.setState({...this.state});
	}

	saveArea() {
		const position_percentage_x = this.new_polygon.x / this.size;
		const position_percentage_y = this.new_polygon.y / this.size;

		var new_area = {
			points:[],
			x:position_percentage_x,
			y:position_percentage_y,
		};

		this.new_polygon.points.map((point, index) => {
			new_area.points.push(point / this.size);
		});

		const last_point_x = this.new_polygon.points[_size(this.new_polygon.points) - 2];
		const last_point_y = this.new_polygon.points[_size(this.new_polygon.points) - 1];

		var has_insersected = false;
		for(var i = 0; i < this.intersection_threshold; i++) {
			const point_x = (last_point_x / this.intersection_threshold) * i + this.new_polygon.x;
			const point_y = (last_point_y / this.intersection_threshold) * i + this.new_polygon.y;

			const element_intersected_close_line = this.refs.layer.getIntersection({ x:point_x, y:point_y }, 'Line');

			if(element_intersected_close_line) {
				if(element_intersected_close_line._id != this.refs.new_polygon._id) {
					alert("Polygon can't be closed since it intersects with other polygon(s)");
					has_insersected = true;
					break;
				}
			}
		}

		var has_collision = false;
		if(!has_insersected) {
			this.state.areas.map((area, index) => {
				//To paint Areas founded
				const middle_point = this.getCenterPolygon(area.points);
				const x_middle = (middle_point.x + area.x) * this.size;
				const y_middle = (middle_point.y + area.y) * this.size;

				const intersected_area = this.refs.layer.getIntersection({ x:x_middle, y:y_middle }, 'Line');

				if(intersected_area) {
					if(intersected_area._id == this.refs.new_polygon._id) {
						alert("Polygon can't be created since it englobes other polygon(s)");
						has_collision = true;
						return false;
					}
				}
			})
		}

		if(!has_insersected && !has_collision) {
			this.state.areas.push(new_area);
			if(this.props.canvasToBuilder != undefined) this.props.canvasToBuilder({ areas:this.state.areas });
			this.removePoint();
		}
	}

	/**
	 * converts KonvaJS points array type (i.e. [x1, y1, x2, y2, x3, y3])
	 * into a points {x,y} arrays (i.e. [{x1, y1}, {x2, y2}, {x3, y3}])
	 */
	convertPointsToPairOfCoordinates(points) {
		if(points[0].x != undefined && points[0].y != undefined) return points;

		var points_xy = [];
		for(var i = 0; i < points.length; i += 2) {
			points_xy.push({
				x:points[i],
				y:points[i + 1],
			});
		}

		return points_xy;
	}

	getCenterPolygon(points) {
		const pts = this.convertPointsToPairOfCoordinates(points);
		const nPts = pts.length;
		var x = 0;
		var y = 0;
		var f;
		var j = nPts-1;
		var p1;
		var p2;

		for(var i = 0; i < nPts; j = i++) {
			p1=pts[i];
			p2=pts[j];

			f = p1.x * p2.y - p2.x * p1.y;
			x += (p1.x + p2.x) * f;
			y += (p1.y + p2.y) * f;
		}

		f = this.getArea(pts) * 6;

		return { x:x/f, y:y/f };
	}

	getArea(points) {
		const pts = points;
		const nPts = pts.length;
		var j = nPts - 1;
		var p1;
		var p2;
		var area = 0;

		for(var i = 0; i < nPts; j = i++) {
			p1 = pts[i];
			p2 = pts[j];
			area += p1.x * p2.y;
			area -= p1.y * p2.x;
		}

		area /= 2;

		return area;
	}

	checkPosition(pos) {
		if(this.new_polygon.x == undefined) this.new_polygon.x = pos.x;
		if(this.new_polygon.y == undefined) this.new_polygon.y = pos.y;

		if(this.new_polygon.points == undefined) {
			this.new_polygon.points = [];
			this.new_polygon.points.push(0);
			this.new_polygon.points.push(0);
		} else {
			const num_points = _size(this.new_polygon.points);
			const last_point_x = this.new_polygon.points[num_points - 2];
			const last_point_y = this.new_polygon.points[num_points - 1];

			const new_point_x = pos.x - this.new_polygon.x;
			const new_point_y = pos.y - this.new_polygon.y;

			const has_intersections = this.checkInsersections({
				x1:last_point_x,
				y1:last_point_y,
				x2:new_point_x,
				y2:new_point_y,
			});

			if(!has_intersections) {
				this.new_polygon.points.push(new_point_x);
				this.new_polygon.points.push(new_point_y);
			}
		}

		this.redrawLayer();
		this.setState({...this.state});
	}

	checkInsersections(line) {
		var has_insersected = false;

		var points_xy = [];
		if(this.new_polygon.points != undefined) {
			for(var i = 0; i < this.new_polygon.points.length; i += 2) {
				points_xy.push({
					x:this.new_polygon.points[i],
					y:this.new_polygon.points[i+1],
				});
			}
		}

		if(_size(points_xy) > 2) {
			for(var index in points_xy) {
				if(index > 0) {
					var new_line = {
						x1:points_xy[index - 1].x,
						y1:points_xy[index - 1].y,
						x2:points_xy[index].x,
						y2:points_xy[index].y,
					};

					const min_value = Math.abs(Math.min(line.x1, line.y1, line.x2, line.y2, new_line.x1, new_line.y1, new_line.x2, new_line.y2));

					has_insersected = this.line_intersect(line.x1 + min_value , line.y1 + min_value, line.x2 + min_value, line.y2 + min_value, new_line.x1 + min_value, new_line.y1 + min_value, new_line.x2 + min_value, new_line.y2 + min_value);
					if(has_insersected) break;
				}
			}
		}

		if(!has_insersected) {
			const this_polygon = this.refs.new_polygon;
			for(var i = 0; i < this.intersection_threshold; i++) {
				const xx = line.x1 + ((line.x2 - line.x1) / this.intersection_threshold) * i + this.new_polygon.x;
				const yy = line.y1 + ((line.y2 - line.y1) / this.intersection_threshold) * i + this.new_polygon.y;

				const element_intersected = this.refs.layer.getIntersection({ x:xx, y:yy }, 'Line');
				if(element_intersected) {
					if(element_intersected._id != this_polygon._id) {
						has_insersected = true;
						break;
					}
				}
			}
		}

		return has_insersected;
	}

	line_intersect(x1, y1, x2, y2, x3, y3, x4, y4) {
		// Check if none of the lines are of length 0
		if((x1 === x2 && y1 === y2) || (x3 === x4 && y3 === y4)) return false;
		if((x1 === x4 && y1 === y4)) return false;

		let denominator = ((y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1));

		// Lines are parallel
		if(denominator === 0) return false;

		let ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator;
		let ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denominator;

		// is the intersection along the segments
		if(ua < 0 || ua > 1 || ub < 0 || ub > 1) return false;

		// Return a object with the x and y coordinates of the intersection
		let x = x1 + ua * (x2 - x1);
		let y = y1 + ua * (y2 - y1);

		return {x, y};
	}

	found(index, e) {
		if(!this.is_builder) {
			//e.evt.stopPropagation();
			this.state.attempts_array.push({
				error:false,
				x:this.state.areas[index].x,
				y:this.state.areas[index].y,
			});

			if(this.state.areas[index] == undefined || !this.state.areas[index].found){
				this.state.areas[index].found = true;
				var is_solved = this.isSolved();
				if(this.props.onFireAttempt != undefined) {
					this.props.onFireAttempt({
						error:false,
					}, is_solved);
				}

				this.successPlay();

				if(this.props.onHitResult != undefined)this.props.onHitResult();
				this.setState({...this.state});
			}
		}
	}

	isSolved() {
		var is_solved = true;
		this.state.areas.map((item, i) => {
			if(item.found == undefined || !item.found) is_solved = false
		});

		/*if(this.props.attempts != undefined && JSON.parse(this.props.attempts) && _size(this.state.attempts_array) >= JSON.parse(this.props.attempts) && !is_solved) {
			if(this.props.onSolve != undefined) this.props.onSolve(false);
		} else */
		if(is_solved) {
			var time = false;
			if(this.props.onSolve != undefined) {
				const stage = this.refs.stage;
				stage.x(0);
				stage.y(0);
				stage.scaleX(1);
				stage.scaleY(1);
				this.props.onSolve(true, { img:stage.toDataURL() });
			}
		}
		
		return is_solved;
	}

	changeLine(index) {
		const line = this.refs['point_' + index].attrs;
		this.new_polygon.points[index * 2] = line.x - this.new_polygon.x;
		this.new_polygon.points[index * 2 + 1] = line.y - this.new_polygon.y;

		this.redrawLayer();
		this.setState({...this.state});
	}

	getDistance(p1, p2) {
		return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
	}

	touchEventsStart(e) {
		if(this.is_builder || this.in_widget) return;

		const touch1 = e.evt.touches[0];

		if(e.evt.touches.length == 2) {
			const touch2 = e.evt.touches[1];

			this.is_zooming = true;

			const dist = this.getDistance(
				{
					x:touch1.clientX,
					y:touch1.clientY,
				},
				{
					x:touch2.clientX,
					y:touch2.clientY,
				}
			);

			if(!this.lastDist) this.lastDist = dist;

			var scale = (this.refs['stage'].scaleX() * dist) / this.lastDist;
			this.stageScaleLimits(scale);

			const angle = Math.atan((touch2.clientY - touch1.clientY) / (touch2.clientX - touch1.clientX));
			const mid_zoom_point = {
				x:touch1.clientX + dist / 2 * Math.cos(angle),
				y:touch1.clientY + dist / 2 * Math.sin(angle),
			}

			const pointer_pos = this.refs['stage'].getPointerPosition();

			const newPosition = {
				x:(mid_zoom_point.x / scale - pointer_pos.x) * scale,
				y:(mid_zoom_point.y / scale - pointer_pos.y) * scale,
			};

			this.refs['stage'].position(newPosition);
			this.stageBoundLimits();

			this.refs['stage'].batchDraw();
			this.lastDist = dist;
		} else if(e.evt.touches.length == 1) {
			this.is_dragging = true;

			const pointer_pos = this.refs['stage'].getPointerPosition();

			this.tap_pos = {
				x:touch1.clientX,
				y:touch1.clientY,
				pointer_x:pointer_pos.x,
				pointer_y:pointer_pos.y,
			};
		}
	}

	dragMove(e) {
		if(this.is_builder) return;

		if(this.is_zooming) {
			this.touchEventsStart(e);
		} else {
			this.is_dragging = true;
		}
		this.stageBoundLimits();
	}

	stageBoundLimits() {
		const stage_x = this.refs['stage'].x();
		const stage_y = this.refs['stage'].y();

		const min_x = this.size * this.refs['stage'].scaleX() - this.size;
		const min_y = this.size * this.refs['stage'].scaleY() - this.size;

		if(stage_x > 0) this.refs['stage'].x(0);
		if(stage_x < -min_x) this.refs['stage'].x(-min_x);
		if(stage_y > 0) this.refs['stage'].y(0);
		if(stage_y < -min_y) this.refs['stage'].y(-min_y);
	}

	stageScaleLimits(scale) {
		if(scale < 1) scale = 1;
		if(scale > 2.5) scale = 2.5;

		this.refs['stage'].scale({ x:scale, y:scale });
	}

	touchEventsStop(e) {
		if(this.is_builder || this.in_widget) return;

		if(e.evt.changedTouches.length == 1) {
			// dragging or tapping
			const moved_dist = this.getDistance(this.tap_pos,
				{
					x:e.evt.changedTouches[0].clientX,
					y:e.evt.changedTouches[0].clientY,
				}
			);

			if(moved_dist < 0.01) {
				this.clickImageTapEmulated({
					x:this.tap_pos.pointer_x,
					y:this.tap_pos.pointer_y,
				});
			}
		}

		this.lastDist = 0;

		var t = setTimeout(() => {
			this.is_zooming = false;
			this.is_dragging = false;
		}, 300);
	}

	mouseWheelZoom(e) {
		if(this.is_builder || this.in_widget) return;

		const stage = this.refs['stage'];

		e.evt.preventDefault();
		var oldScale = stage.scaleX();

		const pointer = stage.getPointerPosition();

		const startPos = {
			x:(pointer.x - stage.x()) / oldScale,
			y:(pointer.y - stage.y()) / oldScale,
		};

		const deltaYBounded = !(e.evt.deltaY % 1) ? Math.abs(Math.min(-10, Math.max(10, e.evt.deltaY))) : Math.abs(e.evt.deltaY);

		const scaleBy = 1.01 + deltaYBounded / 70;
		var newScale = (e.evt.deltaY > 0) ? (oldScale / scaleBy) : (oldScale * scaleBy);
		this.stageScaleLimits(newScale);

		const newPosition = {
			x:(pointer.x / newScale - startPos.x) * newScale,
			y:(pointer.y / newScale - startPos.y) * newScale,
		};

		stage.position(newPosition);
		this.stageBoundLimits();

		stage.batchDraw();
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		const image = this.state.image_search;

		if(this.state.full_loaded && image._src == undefined) {
			return (
				<aside class="game_container is_memory">
					<div class="canvas_content">
						<img src={window.cdn_url + 'img/blank_1x1.png'} class="img_pusher" alt="" />
						<div class="is_fullscreen relative_to_container empty_game_warning not_awesome orangeBg knk-arrow-l-big">
							<span>{i18n("Upload an image with your design")}</span>
							<span class="size_recommendation"><FormattedMessage id="Recommended size: {w}×{h}px" values={{w:800, h:800}} /></span>
							<span class="size_recommendation" style={{margin:'0.5em 1em 0'}}><ActionLink _href={window.zendesk_base_url + '360032890512/#' + ((window.is_spanish) ? 'objetos-ocultos' : 'hidden-objects')} _class={{other:'whiteColor'}} _target="_blank">Read our recommendations to design a good image for the Hidden Objects game</ActionLink></span>
						</div>
					</div>
				</aside>
			)
		}

		const canvas_size = this.size;
		const areas = this.state.areas;
		const attempts = this.state.attempts_array;
		const new_polygon = this.new_polygon;
		const display_legend = (this.props.display_legend != undefined) ? this.props.display_legend : true;

		var points_xy = [];
		if(new_polygon.points != undefined) {
			for(var i = 0; i < new_polygon.points.length; i += 2) {
				points_xy.push({
					x:new_polygon.points[i],
					y:new_polygon.points[i + 1],
				});
			}
		}

		const size_point = 10;

		var actions_xy = {
			x:new_polygon.x + size_point * 2.5,
			y:new_polygon.y + size_point * 2.5,
		};
		if(_size(new_polygon.points) > 2) {
			actions_xy = {
				x:new_polygon.points[_size(new_polygon.points) - 2] + new_polygon.x + size_point * 2.5,
				y:new_polygon.points[_size(new_polygon.points) - 1] + new_polygon.y + size_point * 2.5,
			};
		}

		return (
			<aside class="game_container is_search gui_pos_rel">
				<div class="canvas_content">
					<img src={window.cdn_url + 'img/blank_1x1.png'} class="img_pusher" alt="" />

					{(this.state.full_loaded) ? (
						<Stage className={'canvas_cont'} width={canvas_size} height={canvas_size} ref="stage" draggable={((this.is_zooming || this.is_builder) ? false : true)} onDragMove={(e) => this.dragMove(e)} onTouchMove={(e) => this.touchEventsStart(e)} onTouchEnd={(e) => this.touchEventsStop(e)} onWheel={(e) => this.mouseWheelZoom(e)}>
							<Layer ref="bg_image">
								<Image
									x={0}
									y={0}
									image={image._src}
									scaleX={image._scalex}
									scaleY={image._scaley}
									ref={(solution) => { this.solution = solution; }}
									onClick={(e) => { this.clickImage(e); }}
									onTap={(e) => { this.clickImage(e); }}
									onMouseEnter={() => { document.body.style.cursor = 'pointer'; }}
									onMouseLeave={() => { document.body.style.cursor = 'default'; }}
								/>
							</Layer>

							<Layer ref="layer">
								{areas.map((area, index) => {
									//To pain Areas
									const x = area.x * canvas_size;
									const y = area.y * canvas_size;
									const fill = (this.is_builder) ? 'rgba(' + this.ok_color + ', 0.5)' : 'transparent';
									const stroke = (this.is_builder) ? 'rgba(' + this.ok_color + ', 1)' : 'transparent';

									var points = [];
									for(var i = 0; i < _size(area.points); i++) {
										points.push(area.points[i] * canvas_size);
									}

									//To paint Areas founded
									const middle_point = this.getCenterPolygon(area.points);
									const x_middle = (middle_point.x + area.x) * canvas_size;
									const y_middle = (middle_point.y + area.y) * canvas_size;

									const found_color = (this.state.hover_area === index) ? 'rgba(' + this.ok_color_hover + ', 1)' : 'rgba(' + this.ok_color + ', 1)';

									return (
										<Group key={'area'+index}>
											<Line
												ref={'area'+index}
												x={x}
												y={y}
												points={points}
												stroke={stroke}
												strokeWidth={2}
												closed={true}
												fill={fill}
												draggable={false}
												perfectDrawEnabled={false}
												onClick={(e) => this.found(index, e)}
												onTap={(e) => this.found(index, e)}
												onMouseEnter={() => { this.setState({ hover_area:index }); document.body.style.cursor = 'pointer'; }}
												onMouseLeave={() => { this.setState({ hover_area:false }); document.body.style.cursor = 'default'; }}
											/>

											{(!this.is_builder && area.found) && (
												<Circle
													x={x_middle}
													y={y_middle}
													radius={15}
													fill='transparent'
													stroke={found_color}
													strokeWidth={5}
													onMouseEnter={() => { document.body.style.cursor = 'pointer'; }}
													onMouseLeave={() => { document.body.style.cursor = 'default'; }}
												/>
											)}
										</Group>
									)
								})}

								{!this.is_builder && attempts.map((attempt, index) => {
									if(!attempt.error) return null
									const offset = size_point;

									const fail_props = {
										stroke:`rgba(${this.ko_color}, 1)`,
										strokeWidth:5,
										lineCap:'round',
										...attempt,
									};

									return (
										<Group key={'missed_'+index}>
											<Line ref={'cross1_' + index} points={[-offset, offset, offset, -offset]} {...fail_props} />
											<Line ref={'cross2_' + index} points={[-offset, -offset, offset, offset]} {...fail_props} />
										</Group>
									)
								})}

								{(this.is_builder) && (
									<>
										{areas.map((area, index) => {
											const middle_point = this.getCenterPolygon(area.points);

											const x = (middle_point.x + area.x) * canvas_size;
											const y = (middle_point.y + area.y) * canvas_size;

											const area_name = (area.name != undefined && area.name != "") ? area.name : i18n("Area") + "_" + index;
											const visible = (this.state.hover_area === index) ? true : false;

											return (
												<Label key={'label_' + index} x={x} y={y} visible={visible}>
													<Tag fill='black' lineJoin='round' />

													<Text text={area_name} fill='white' fontSize={15} padding={5} fontFamily="Calibri" />
												</Label>
											)
										})}

										{(new_polygon.points != undefined && _size(new_polygon.points) > 2) && (
											<Line
												ref="new_polygon"
												x={new_polygon.x}
												y={new_polygon.y}
												points={new_polygon.points}
												hitStrokeWidth={0}
												strokeWidth={2}
												stroke={'rgba(' + this.creating_color + ', 1)'}
												fill={'rgba(' + this.creating_color + ', 0.2)'}
												closed={true}
												draggable={false}
												onClick={(e) => this.clickImage()}
												onTap={(e) => this.clickImage()}
												perfectDrawEnabled={false}
											/>
										)}

										{(_size(points_xy) > 0) && (
											(points_xy).map((point, index) => {
												return (
													<Rect
														key={'point'+index}
														ref={'point_'+index}
														x={new_polygon.x + point.x}
														y={new_polygon.y + point.y}
														offsetX={size_point / 2}
														offsetY={size_point / 2}
														width={size_point}
														height={size_point}
														fill={'rgba(' + this.creating_color + ', 1)'}
														draggable={true}
														onTouchMove={() => this.changeLine(index)}
														onDragMove={() => this.changeLine(index)}
													/>
												)
											})
										)}
									</>
								)}
							</Layer>
						</Stage>
					) : (
						<div class="gui_not_in_top gui_flex_center" style={{'--main-text-color':'var(--secondary-color)'}}>
							<Spinner color='rgba(var(--secondary-color), 1)'>Loading game</Spinner>
						</div>
					)}
				</div>

				{(new_polygon.points != undefined && this.is_builder) && (
					<ButtonCollection _class={{other:'point_actions'}} style={{left:actions_xy.x, top:actions_xy.y}}>
						<SquaredButton
							disabled={(_size(new_polygon.points) > 4) ? false : true}
							onClick={() => this.saveArea()}
							color="green"
							icon='knk-on'
							tooltip={<Tooltip with_icon={false} position="top">Save path</Tooltip>}
							aria-label="Save path"
						/>

						<SquaredButton
							disabled={(_size(new_polygon.points) > 2) ? false : true}
							onClick={() => this.removeLast()}
							icon='knk-rotate-cw'
							tooltip={<Tooltip with_icon={false} position="top">Undo</Tooltip>}
							aria-label="Undo"
						/>

						<SquaredButton
							onClick={() => this.removePoint()}
							color='red'
							icon='knk-off'
							tooltip={<Tooltip with_icon={false} position="top">Delete area</Tooltip>}
							aria-label="Delete area"
						/>
					</ButtonCollection>
				)}

				{(display_legend) && (
					<Legend items={areas} intl={this.props.intl} />
				)}
			</aside>
		);
	}
}
export default injectIntl(SearchCanvas);